import { useRouteMatch, useLocation } from 'react-router-dom';
import { HasPermission } from 'react-role-permission';
import { getAppLinkPath } from './utils/link.utils';
import MainLayout from './app/layouts/MainLayout';
import PublicViewLayout from './app/layouts/PublicViewLayout';

import 'react-toastify/dist/ReactToastify.css';

const App = ({ children, embed = false }) => {
  const location = useLocation();
  const pathname = getAppLinkPath(location.pathname);
  const isView = useRouteMatch({ path: ['*/sessions/view*'], exact: true });
  const usePublicViewLayout = isView && !HasPermission(pathname);

  return usePublicViewLayout
    ? <PublicViewLayout embed={embed}>{children}</PublicViewLayout>
    : <MainLayout embed={embed}>{children}</MainLayout>;
}

export default App;
